var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-38.17 0 497.587 497.587",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-2265.367 -2350.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M2124.062-1502.463a47.56,47.56,0,0,1-1.08,19.92,61.123,61.123,0,0,1-19.893,30.107c-.827.68-1.667,1.32-2.52,1.947-16.187,11.813-37,15.906-57.013,15.04-17.573-.773-35.613-5.467-48.947-16.933s-20.84-30.707-15.107-47.347a42.86,42.86,0,0,1-8.227-43.346,42.91,42.91,0,0,1,35.106-26.72,54.684,54.684,0,0,1,38.04-25.44c10.573-1.6,21.333.76,30.827,5.48,7.6,3.787,18.08,9.92,21.453,18.16,2.387,5.854.68,12.373,2,18.427,2.747,12.493,14.307,20.907,19.707,32.187a64.385,64.385,0,0,1,5.653,18.52",
    transform: "translate(490 4018.328)",
    fill: "#6a3b1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M1901.569-1246.176l-26.28,28.293s1.307,6.163-9.52,16.667-34.187,28.292-36,27.407.48-5.816,4.733-11.6,13.867-10.467,11.453-13.145-60.133,20.931-62.067,17.889,43.693-22.729,42.427-24.4-48.72,17.133-50.773,13.432,14.773-11.253,14.773-11.253-12.547,4.287-12.64.213,45.106-18.9,41.373-21.333-39.906,8.919-37.786,2.792,67.493-20.145,67.493-20.145l24.867-33.616,27.947,28.8",
    transform: "translate(490 4018.328)",
    fill: "#fec2a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M1790.422-1202.606l-.213-.553c.293-.113,28.96-11.409,32.187-13.015l.267.531c-3.253,1.617-31.053,12.572-32.24,13.037",
    transform: "translate(490 4018.328)",
    fill: "#e2474d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M1973.649-1338.05s3.893,47.74-7.773,84.936c-5.453,17.424-13.84,51.549-21.213,82.905h213.386c-5.746-27.363-12.853-57.083-20.067-76.8-16.653-45.524,25.227-206.229,2.187-224.536-13.147-10.44-58.587-20.333-58.587-20.333-17.213,2.227-59.08.04-80.173,11.147s-146.573,216.578-146.573,216.578c.547,21.1,38.866,39.351,38.866,39.351l79.946-113.249",
    transform: "translate(490 4018.328)",
    fill: "#4f334b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M1973.649-1337.757a.293.293,0,0,1-.293-.28c-.013-.187-.933-18.707-.267-41.787.613-21.32,2.76-51,9.467-71.36a.314.314,0,0,1,.387-.187.314.314,0,0,1,.187.387c-6.693,20.28-8.827,49.893-9.44,71.173-.68,23.053.253,41.56.253,41.733a.291.291,0,0,1-.28.32h-.013",
    transform: "translate(490 4018.328)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "M2082.075-1170.209c-3.293-30.639-6.813-65.105-8.64-88.257-.227-2.821-.427-5.476-.6-7.933-3.2-46.664,21.987-197.17,21.987-197.17-23.96-14.773-80.187,10.867-80.187,10.867s-9.48,60.2-14.467,110.427c-1.693,17.113-3.6,50.364-5.387,86.757-1.387,28.591-2.693,59.125-3.773,85.311h91.066",
    transform: "translate(490 4018.328)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M2112.475-1483.65l2.04,61.933-14.587,18.52,14.587,16.746-41.947,112.917s11.44-148.277,16.187-174.237,11.173-39.547,11.173-39.547,10.52.867,12.547,3.667",
    transform: "translate(490 4018.328)",
    fill: "#6b4668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M2007.1-1483.25l-23.68,64.026,11.84,10.68-10.053,17.467,10.28,121.43s16.44-173.444,19.64-191.257,6.6-26.187,6.6-26.187-8.947-.227-14.627,3.84",
    transform: "translate(490 4018.328)",
    fill: "#6b4668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M2072.142-1509.383s32.04,6.427,32.173,14.88-18.906,55.093-18.906,55.093-14.467-12.067-19.307-8.44c-4.813,3.613-20.107,10.453-20.107,10.453l-16.48-6.04-14.88,14.48v-49.467s10.053-14.48,20.507-19.293,37-11.667,37-11.667",
    transform: "translate(490 4018.328)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "M2045.995-1437.4s-14.133-42.293-16.667-52.373l-.013-.067c-2.494-9.987-19.707-63.56-19.707-63.56l48.026-9.44s11.6,39.92,14.507,53.453c.04.187.107.413.16.653,1.773,7.373,10.546,36.906-26.307,71.333",
    transform: "translate(490 4018.328)",
    fill: "#fec2a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M2072.3-1508.73a67.028,67.028,0,0,1-20.68,13.547c-6.413,2.653-14.627,5.067-22.293,5.413l-.013-.067c-2.494-9.987-19.707-63.56-19.707-63.56l48.026-9.44s11.6,39.92,14.507,53.453c.04.187.107.413.16.653",
    transform: "translate(490 4018.328)",
    fill: "#e96e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M2082.075-1170.209c-3.293-30.639-6.813-65.105-8.64-88.257l-78.653,2.947c-1.387,28.591-2.693,59.125-3.773,85.311h91.066",
    transform: "translate(490 4018.328)",
    fill: "#6f5de7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M2145.008-1515.756l10.187,35-39.84,4.8-3.773-21.773-2.827-16.28s-5.68-2.693-7.493-17.667c-1.787-14.987-1.787-44.346,0-45.253,1.813-.893,4.36,3.893,6.387,10.787s-.08,17.387,3.52,17.08,19.773-60.52,23.36-60.213-8.387,48.52-6.293,48.52,15.867-49.133,20.067-48.52c4.12.587.173,17.827.013,18.533.227-.68,4.28-12.48,7.48-10.147,3.293,2.4-12.28,47.333-8.093,45.84s17.08-37.147,20.68-31.76-24.866,65.906-24.866,65.906l1.493,5.147",
    transform: "translate(490 4018.328)",
    fill: "#fec2a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M2155.195-1480.756l-39.84,4.8-3.773-21.773c9.133-5.187,24.707-13.44,33.427-18.027l10.187,35",
    transform: "translate(490 4018.328)",
    fill: "#e96e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M2139.448-1557.129l-.573-.12c.68-3.56,8.8-32.32,9.147-33.533l.573.16c-.08.293-8.467,29.96-9.146,33.493",
    transform: "translate(490 4018.328)",
    fill: "#e2474d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M2153.848-1548.076c-11.613-8.907-33.507-14.413-33.72-14.467l.133-.573c.227.053,22.24,5.587,33.947,14.573l-.36.467",
    transform: "translate(490 4018.328)",
    fill: "#e2474d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M2154.995-1502.89s44.067,132.186,41.52,158.866c-2.533,26.7-42.36,46.61-63.546,10.173s-26.693-149.133-26.693-149.133,30.08-22.453,48.72-19.906",
    transform: "translate(490 4018.328)",
    fill: "#4f334b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "M2136.928-1327.638l-.227-.116a52.643,52.643,0,0,1-3.987-5.949c-8.32-14.293-15.2-41.72-20.467-81.52-4.04-30.573-5.76-58.4-6.187-66.2a.308.308,0,0,1,.28-.32.3.3,0,0,1,.32.293c.427,7.787,2.146,35.6,6.187,66.146,5.253,39.72,12.106,67.08,20.373,81.307a53.758,53.758,0,0,0,3.947,5.879.289.289,0,0,1-.053.417l-.187.063",
    transform: "translate(490 4018.328)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M2075.008-1528.943c-5.4,18.84-38.013,38.627-53.187,39.36s-38-14.227-42.72-32.187a132.292,132.292,0,0,1-3.32-19.973c-1.253-12.813-1.16-24.067-1.16-24.067,14.2-47.146,73.587-41.48,83.893-32.667,3.64,3.12,7.44,10.387,10.6,19.293,5.76,16.28,9.373,38.053,5.893,50.24",
    transform: "translate(490 4018.328)",
    fill: "#fec2a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M2069.115-1579.183c-4.533,6.24-11.613,10.36-22.48,10.067-31.053-.827-58.76,17.84-70.853,27.373-1.253-12.813-1.16-24.067-1.16-24.067,14.2-47.147,73.586-41.48,83.893-32.667,3.64,3.12,7.44,10.387,10.6,19.293",
    transform: "translate(490 4018.328)",
    fill: "#e96e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M2091.9-1597.623c3.04,5.24,4.32,12.96,5.173,18.16a73.08,73.08,0,0,1-.28,24.92c-1.213,6.413-3.4,12.867-7.786,17.68,7.293-8,2.146-20.266-7.533-22.707-5.293-1.333-9.107,2.973-10.533,7.747a20.386,20.386,0,0,0,1.693,15.547c-6.187-1.507-11.546-5.573-15.546-10.533s-6.787-10.8-9.187-16.693c-3.827-9.413-6.787-19.973-3.52-29.587-3.307,6.067-6.04,10.547-13.346,12.107-5.787,1.24-11.813.48-17.707.933a42.744,42.744,0,0,0-23.16,9.373,42.172,42.172,0,0,0-8.667,9.227c-2.2,3.293-5.307,6.32-5.653,10.493.173-2.027-1.36-5.187-1.76-7.24-.56-2.787-.96-5.613-1.24-8.44a88.487,88.487,0,0,1-.027-16.493,86.928,86.928,0,0,1,3.053-16.213c1.56-5.427,3.24-8.547,7.253-12.467,8.787-8.56,20.987-13.747,33.253-13.307s24.36,6.773,31.04,17.067c-.08-.12,9.44-2.24,10.36-2.333a44.165,44.165,0,0,1,11.093.4c7.04,1.133,14.72,3.987,20.16,8.747a13.728,13.728,0,0,1,2.866,3.613",
    transform: "translate(490 4018.328)",
    fill: "#6a3b1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M2080.768-1561.689a12.335,12.335,0,0,1,11.253,5.787,15,15,0,0,1,1.187,12.827,19.18,19.18,0,0,1-8.547,9.88,9.967,9.967,0,0,1-6.32,1.6,9.4,9.4,0,0,1-5.867-4.053c-5.773-7.867-3.493-24.933,8.293-26.04",
    transform: "translate(490 4018.328)",
    fill: "#fec2a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M2073.915-1552.516a12.768,12.768,0,0,0-.094,10.68c.707,1.68,1.92,3.373,3.707,3.72a4.4,4.4,0,0,0,3.88-1.507,9.093,9.093,0,0,0,1.893-3.853c.947-3.467,1.68-10.133-.88-13.147s-7.333,1.8-8.507,4.107",
    transform: "translate(490 4018.328)",
    fill: "#e96e5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M2080.368-1535a12.332,12.332,0,0,1-7.853-12.467c.187-3.333,2.12-7.68,5.44-9.56a6.422,6.422,0,0,1,6.387,0,7.474,7.474,0,0,1,3.853,7.987l-.467-.107a6.991,6.991,0,0,0-3.613-7.467,5.938,5.938,0,0,0-5.92,0c-3.173,1.8-5.027,5.973-5.2,9.173a11.845,11.845,0,0,0,7.533,11.987l-.16.453",
    transform: "translate(490 4018.328)",
    fill: "#e2474d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M2092.595-1576.1l61.427-45.373-144.16-46.32-86.933,79.226,47.253,15.613s94.64-19.827,122.413-3.146",
    transform: "translate(490 4018.328)",
    fill: "#4f334b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M2098.141-1562.076s-34.12-25.307-76.373-15.773-47.08,29.547-47.08,29.547l-9.76-53.453s25.8-27.453,69.786-27.8,66.373,18.08,66.373,18.08l-2.947,49.4",
    transform: "translate(490 4018.328)",
    fill: "#6b4668"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentFemale);
export default __webpack_public_path__ + "static/media/student-female.3c7f4ecc4c403530fd81b53f4c621b40.svg";
export { ForwardRef as ReactComponent };